import { trigger, state, style, transition, animate, query, stagger, group } from '@angular/animations';

const segmentTransition = '0.5s cubic-bezier(0.645, 0.045, 0.355, 1)';

export const segmentAnimation = trigger('segmentAnimation', [
  state('*', style({
    opacity: 0,
    transform: 'translate3d(-150px, 0, 0) scale(0.97)',
  })),
  state('show', style({
    opacity: 1,
    transform: 'none',
  })),
  state('hide', style({
    opacity: 0,
    transform: 'translate3d(150px, 0, 0) scale(0.97)'
  })),
  transition('* => show', [
    query('.fadeInAnimation', style({ opacity: 0 }), { optional: true }),
    group([
      query('.fadeInAnimation',
        stagger('0.1s', [
          animate('0.5s ease-in', style({ opacity: 1 }) )
        ]),
        { optional: true }),
      animate(segmentTransition),
    ])
  ]),
  transition('show => hide', [
    animate(segmentTransition)
  ]),
  transition('* => void', [
    animate(segmentTransition, style({
      opacity: 0,
      transform: 'translate3d(150px, 0, 0) scale(0.97)'
    }))
  ]),
]);

export const segmentAnimationEmpty = trigger('segmentAnimation', []);
